var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefresh2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "refresh",
    d: "M1.3335 8.00004C1.3335 4.32004 4.2935 1.33337 8.00016 1.33337C12.4468 1.33337 14.6668 5.04004 14.6668 5.04004M14.6668 5.04004V1.70671M14.6668 5.04004H11.7068",
    stroke: "#171D27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "refresh",
    d: "M14.5933 8C14.5933 11.68 11.6067 14.6667 7.92667 14.6667C4.24667 14.6667 2 10.96 2 10.96M2 10.96H5.01333M2 10.96V14.2933",
    stroke: "#171D27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh2);
export default __webpack_public_path__ + "static/media/refresh-2.efa742b79e4da00b397bb994e445e5c7.svg";
export { ForwardRef as ReactComponent };